export default __webpack_public_path__ + "static/media/WinterBook_00.34bf5358.png";